var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownArrowUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 4.574,
    viewBox: "0 0 8 4.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M12.629,10.193l3.027-3.025a.572.572,0,0,0-.81-.807L11.417,9.788a.571.571,0,0,0-.017.788l3.444,3.451a.572.572,0,1,0,.81-.807Z",
    transform: "translate(-6.194 15.824) rotate(-90)",
    fill: "#0062ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownArrowUnfilled);
export default __webpack_public_path__ + "static/media/IconDownArrowUnfilled.fe95ad2c.svg";
export { ForwardRef as ReactComponent };